import { render } from "./OvAbortModal.vue?vue&type=template&id=6eaec3fb&scoped=true"
import script from "./OvAbortModal.vue?vue&type=script&lang=js"
export * from "./OvAbortModal.vue?vue&type=script&lang=js"

import "./OvAbortModal.vue?vue&type=style&index=0&id=6eaec3fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eaec3fb"]])

export default __exports__